import DateFormatter from "@/components/DateFormatter";
import Image from "next/image";
import Link from "next/link";

const Avatar = ({ author, date }) => {
  return (
    <div className="flex items-center sm:justify-center lg:justify-start">
      {/* {Object.keys(author.node.avatar.url).length > 0 && (
        <Image
          className="h-10 w-10 rounded-full object-cover"
          src={author.node.avatar.url}
          width={2400}
          height={1600}
          alt={`${author.node.name} avatar`}
        />
      )} */}
      <div className="byline flex">
        <div
        // className={`author ${
        //   Object.keys(author.node.avatar.url).length > 0 ? "ml-3" : ""
        // }`}
        >
          {author.node.name}{" "}
        </div>
        <div className="date ml-1 text-gray-500">
          · <DateFormatter dateString={date} />
        </div>
      </div>
    </div>
  );
};

export default Avatar;
